export const SIGNUP_TEXT = {
  // Left Section
  heroTitle: "Your practice,",
  heroSubtitle1: "professionally",
  heroSubtitle2: "booked.",

  heroDescription:
    "Sign in to manage bookings, clients, credentials, and payouts — all in one place.",

  copyright: "© 2026 TulluApp",

  // Top Right
  newToTullu: "New to Tullu?",
  howItWorks: "See how it works",

  // Heading
  title: "Apply to partner with Tullu",

  subtitle:
    "Create your free partner account, or sign in if you already have one.",

  // Social Buttons
  google: "Continue with Google",
  apple: "Continue with Apple",

  // Toggle
  or: "OR",

  emailTab: "Email",
  phoneTab: "Phone",

  // Email
  emailLabel: "Email Address",
  emailPlaceholder: "you@yourpractice.com",
  emailHint: "We'll email you a 6-digit verification code.",

  // Phone
  phoneLabel: "Phone Number",
  phonePlaceholder: "(480) 555-1234",
  phoneHint: "We'll text you a 6-digit verification code.",
  countryCode: "+1",

  // Buttons
  continue: "Continue",

  // Links
  usePhone: "Use phone instead",
  and: "and",

  // Terms
  termsPrefix: "By continuing you agree to our",
  terms: "Terms of Service",
  privacy: "Privacy Policy",

  smsConsent:
    "By providing your number, you consent to receive a one-time verification code via SMS. Msg & data rates may apply.",

  /* ---------- How It Works Popup ---------- */

  providersBadge: "FOR PROVIDERS",

  howItWorksTitle: "How Tullu works",

  howItWorksSubtitle:
    "From application to payout — four steps to a fully managed practice.",

  gotIt: "Got it",

  fullWalkthrough: "See the full walkthrough",
};

export const FEATURES = [
  "Verified providers only",
  "Stripe-powered payouts",
  "Now serving Arizona",
];

export const HOW_IT_WORKS_STEPS = [
  {
    id: 1,
    title: "Apply & get verified",
    description:
      "Create your free account. We check your license and credentials, so every provider clients see is the real thing.",
  },
  {
    id: 2,
    title: "Set up your practice",
    description:
      "Add your services, hours, locations, and team — and set your own prices.",
  },
  {
    id: 3,
    title: "Get booked",
    description:
      "Clients discover and book you on the Tullu marketplace. Bookings, clients, and consent forms all live in one place.",
  },
  {
    id: 4,
    title: "Get paid",
    description:
      "You're the merchant of record, so your service revenue stays yours. Stripe handles payouts on one flat monthly plan — no commission on what you earn.",
  },
];

/* ---------- Need Help Modal ---------- */

export const NEED_HELP_TEXT = {
  title: "Need help?",

  commonReasons: "COMMON REASONS",

  whatToTry: "WHAT TO TRY",

  supportTitle: "Still having trouble?",

  supportDescription:
    "Contact support — we're here to help.",

  supportEmail: "support@tulluapp.com",

  close: "Close",
};

export const NEED_HELP_REASONS = [
  {
    icon: "clock",
    title: "Delivery delay",
    text:
      "Codes usually arrive within a minute, sometimes a little longer.",
  },
  {
    icon: "mail",
    title: "Check spam",
    text:
      "Look in your spam, junk, or promotions folder.",
  },
  {
    icon: "mail",
    title: "Wrong email",
    text:
      "Go back and verify you entered the correct email address.",
  },
  {
    icon: "shield",
    title: "Inbox filtering",
    text:
      "Work or school inboxes may block outside senders — try a personal email.",
  },
];

export const NEED_HELP_STEPS = [
  "Wait a minute for the email to arrive",
  "Check your spam or junk folder",
  "Confirm your email address is correct",
  'Tap "Resend code" if available',
];

export const OTP_LENGTH = 6;

export const MAX_ATTEMPTS = 3;

export const LOCK_DURATION = 300;

export const RESEND_SECONDS = 30;